import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromUser from './user/user.reducer';
import * as fromRegister from '../auth/register/reducers/register.reducer';
import * as fromLogin from '../auth/login/reducers/login.reducer';
import * as fromCalculator from '../calculator/calculator/calculator.reducer';
import * as fromOrders from '../dashboard/orders/orders.reducer';
import * as fromNotifications from './notification/notification.reducer';
import * as fromConversation from './chatmessages/conversation.reducer';

export interface AppState {
  [fromUser.userFeatureKey]: fromUser.UserState;
  [fromRegister.registerFeatureKey]: fromRegister.State;
  [fromLogin.loginFeatureKey]: fromLogin.State;
  [fromCalculator.calculatorFeatureKey]: fromCalculator.State;
  [fromOrders.ordersFeatureKey]: fromOrders.State;
  [fromNotifications.notificationsFeatureKey]: fromNotifications.State;
  [fromConversation.conversationsFeatureKey]: fromConversation.State;
}

export const reducers: ActionReducerMap<AppState> = {

  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromRegister.registerFeatureKey]: fromRegister.reducer,
  [fromLogin.loginFeatureKey]: fromLogin.reducer,
  [fromCalculator.calculatorFeatureKey]: fromCalculator.reducer,
  [fromOrders.ordersFeatureKey]: fromOrders.reducer,
  [fromNotifications.notificationsFeatureKey]: fromNotifications.reducer,
  [fromConversation.conversationsFeatureKey]: fromConversation.reducer
};


export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
